<template>
  <div>
    <div v-if="timeLimit" class="timer-text">
      {{ $t('timeToComplete') + `: ${timer} ` + $t('minutes') }}
    </div>
    <div class="time-left-container">
      <div class="time-left-container-row">
        <div>
          <template v-if="timeLeft <= 60">
            <img :src="require('../../assets/img/test/red-timer.svg')" alt="">
          </template>
          <template v-else>
            <img :src="require('../../assets/img/test/timer.svg')" alt="">
          </template>
        </div>
        <div class="time-left-text">
          {{ $t('left') }}:
        </div>
        <div
          class="time-left-label pt-1"
          :class="{ 'time-left-label-warning' : timeLeft <= 60}"
        >
          {{ timeLeftString }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InterviewTimer',
  props: {
    timer: {
      type: Number,
      required: true,
    },
    timeLimit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      timeLeft: this.timeLimit,
      timerInterval: null,
    };
  },
  computed: {
    timeLeftString() {
      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = this.timeLeft % 60;

      return `${this.padToTwo(minutes)}:${this.padToTwo(seconds)}`;
    },
  },
  watch: {
    timeLimit(newTime) {
      this.timeLeft = newTime;
    },
    timeLeft(value) {
      if (value === 0) {
        this.finishTest();
      }
    },
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    padToTwo(num) {
      return String(num).padStart(2, '0');
    },
    async finishTest() {
      this.$emit('finish');
    },
    startTimer() {
      if (this.timerInterval) return;

      this.timerInterval = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft -= 1;
        } else {
          this.stopTimer();
          this.$emit('finish');
        }
      }, 1000);
    },
    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.close-button {
  position: absolute;
  right: 15px;
  top: 15px;
}

.textDialog {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin: 20px 0;
}

.time-left-text, .time-left-label {
  font-size: 14px;
  line-height: 16.8px;
  font-weight: 400;
  color: black;
}

.time-left-label-warning {
  color: red;
}

.timer-text {
  color: #333333;
  font-size: 14px;
  line-height: 16.8px;
  margin-bottom: 8px;
  display: none;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .time-left-container, .time-left-container-row {
    display: flex;
    align-items: center;
  }
  .time-left-container-row img {
    margin-bottom: -2px;
  }
  .time-left-text {
    margin: 0 3px 0 8px;
  }
  .timer-text {
    display: block;
  }
}
</style>

<i18n locale="en" lang="yaml">
  textDialog: Your testing time has expired, and the test results have been transferred to the employer.
  close: Close
  left: Time remaining
  timeToComplete: Time to complete
  minutes: min
</i18n>

<i18n locale="ru" lang="yaml">
  textDialog: У вас истекло время на тестирование, результаты тестирования переданы работодателю.
  close: Закрыть
  left: Осталось
  timeToComplete: Время для прохождения
  minutes: мин.
</i18n>
